(function ($) {
    Drupal.behaviors.memberStatesQuestionFilter = {
        attach: function (context, settings) {
            $('.questions', context).click(function () {
                $("#questions").attr("name", $(this).val()+"[1]");
            });
            
            $('#edit-reset-member-states', context).click(function () {
                window.location.reload(); 
            });
            
        }
       
    };
})(jQuery);
